import { createAction } from 'redux-actions'

export const setSurveyAttemptState = createAction('SET_SURVEY_ATTEMPT_STATE')
